import { Component, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-full-about',
  templateUrl: './full-about.component.html',
  styleUrls: ['./full-about.component.scss']
})
export class FullAboutComponent implements OnInit {
  introductionVideo: SafeResourceUrl | null = null;

  constructor(private renderer: Renderer2, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.scrollToTop();
    this.loadIntroductionVideo();
  }

  scrollToTop(): void {
    this.renderer.setProperty(document.body, 'scrollTop', 0);
    this.renderer.setProperty(document.documentElement, 'scrollTop', 0);
  }

  loadIntroductionVideo(): void {
    const arVideoUrl = 'https://www.youtube.com/embed/8hF1SMMIRHY?si=JVxpVFrdgun-wwHv';
    const enVideoUrl = 'https://www.youtube.com/embed/weZ1hdHWyYM?si=AvH9XLvg5MaE5F7W';

    const language = localStorage.getItem('language') || 'en'; 


    const videoUrl = language === 'ar' ? arVideoUrl : enVideoUrl;
    this.introductionVideo = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
  }
}
